module.exports = __webpack_public_path__ + "static/media/Intelli-Logo-crop-2-1.e906a754.svg";